import React from "react";
import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";

// 右侧边栏

const query = graphql`
  {
    allStrapiTrend(sort: { fields: date, order: DESC }, limit: 3) {
      nodes {
        title
        slug
        content
        image {
          childImageSharp {
            fixed {
              src
            }
          }
        }
        date
      }
    }
  }
`;

const Sidebar = () => {
  const data = useStaticQuery(query);
  const {
    allStrapiTrend: { nodes: trends },
  } = data;
  return (
    <div className="widget-area">
      <div className="widget widget_tracer_posts_thumb">
        <h3 className="widget-title">客户案例</h3>
        {trends.map((trend, idx) => {
          return (
            <article className="item">
              <Link to={`/trend/${trend.slug}`} className="thumb">
                {trend.image && trend.image.childImageSharp && (
                  <img
                    src={trend.image.childImageSharp.fixed.src}
                    alt="人力资源软件"
                  />
                )}
              </Link>
              <div className="info">
                <span>{trend.date}</span>

                <h4 className="title usmall">
                  <Link to={`/trend/${trend.slug}`}>{trend.title}</Link>
                </h4>
              </div>
              <div className="clear"></div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
